import { validatePhoneNumber } from '@spike/validations';

/**
 * Validates a phone number for an organization
 * @param phone - The phone number to validate
 * @param country - The country code for validation (e.g., 'US')
 * @returns Error message if validation fails, undefined if valid
 */
export const validatePhone = (phone: string | undefined, country: string): string | undefined => {
    if (!phone?.trim()) {
        return 'Phone is required';
    }

    const validationErrors = validatePhoneNumber(phone, country, 'phone');
    if (validationErrors.length > 0) {
        return validationErrors[0].errorMessage;
    }

    return undefined;
};

/**
 * Validates a phone number without requiring it to be filled
 * @param phone - The phone number to validate
 * @param country - The country code for validation
 * @returns Error message if validation fails, undefined if valid or empty
 */
export const validateOptionalPhone = (phone: string | undefined, country: string): string | undefined => {
    if (!phone?.trim()) {
        return undefined;
    }

    const validationErrors = validatePhoneNumber(phone, country, 'phone');
    if (validationErrors.length > 0) {
        return validationErrors[0].errorMessage;
    }

    return undefined;
};
